import { render, staticRenderFns } from "./talent.vue?vue&type=template&id=1c56b0fc&scoped=true"
import script from "./talent.vue?vue&type=script&lang=js"
export * from "./talent.vue?vue&type=script&lang=js"
import style0 from "./talent.vue?vue&type=style&index=0&id=1c56b0fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c56b0fc",
  null
  
)

export default component.exports